import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { UserChangePassword, UserCreate, UserEntity, UserProfile, UserUpdate } from '../models';
import { getFieldToUpdateModel } from '../adapters';

@Injectable({
  providedIn: 'root',
})
export class UserApiService extends BaseApi<UserEntity> {
  constructor() {
    super('', {
      get: '/User/admin/GetUserList'
    });
  }

  getProfile(id: number) {
    return http$.post<UserProfile>('/User/admin/ViewUserProfile', { userId: id });
  }

  createUser(model: UserCreate) {
    return http$.post('/User/admin/CreateUser', model);
  }

  updateUser(id: number, model: UserUpdate) {
    return http$.put('/User/admin/EditUser', { userid: id, user: getFieldToUpdateModel(model) });
  }

  deleteUser(id: number) {
    return http$.delete('/User/admin/DeleteUser', { body: { userId: id } });
  }

  changePassword(id: number, model: UserChangePassword) {
    return http$.post('/User/admin/ChangePassword', { userId: id, ...model });
  }

  getUserItems() {
    return this.getItemRecords(user => `${user.firstName} ${user.lastName}`);
  }
}
